export const companyInfo = {
  name: "ファクトケイ株式会社",
  address: "〒146-0084 東京都大田区南久が原2-23-19",
  tel: "03-3757-2881",
  fax: "03-3757-2861",
  yokohamaAddress: "〒246-0013 神奈川県横浜市瀬谷区相沢7-17-6",
  yokohamaTel: "045-301-4282",
  yokohamaFax: "045-301-9484",
  founded: "昭和52年4月2日",
  capital: "1千万円",
  employees: "15人",
  bank: "三菱UFJ銀行",
  invoiceNumber: "T5020001090983",
  associations: [
    "日本試験機工業会",
    "東京科学機器協会",
    "一般財団法人日本規格協会",
  ],
  business: [
    "接触抵抗評価分析",
    "環境試験、信頼性試験、依頼試験、受託腐食試験",
    "接触抵抗・接触抵抗評価システムの製造販売",
    "ガス試験・ガス腐食試験・ガス腐食試験機の製造販売",
    "防錆処理・ルブリカント・コンタクト用表面処理剤の販売",
  ],
  greeting:
    "私どもは「地球上より接触不良を無くしたい」という考えから接触機構部品のガス腐食試験、接触抵抗評価分析、およびメタルコンタクト表面処理液を専門に扱う研究所として誕生し、お得意様と悩み考え歩んでまいりました。\n昭和52年4月創業以来、今日のように成長出来ましたのも、ひとえに関係者各業界の皆様の暖かいご支援の賜りと深く感謝しております。\n今後ともお得意様の企業発展に少しでも貢献する事が私どもの使命と考え、企画活動を続ける覚悟です。\nどうぞこれまでにも増して、御指導のほどお願い申し上げます。",
  vision: "地球上より接触不良を無くしたい",
};

export const navLinks = [
  { label: "ホーム", path: "/" },
  { label: "お知らせ", path: "/news" },
  { label: "サービス", path: "/service" },
  { label: "製品", path: "/products" },
  { label: "会社案内", path: "/company" },
  { label: "採用情報", path: "/recruit" },
  { label: "レポート", path: "/report" },
  { label: "リンク", path: "/links" },
  { label: "お問い合わせ", path: "/contact" },
];